import { render, staticRenderFns } from "./HomeVideo.vue?vue&type=template&id=ed7e6dfc&scoped=true&"
import script from "./HomeVideo.vue?vue&type=script&lang=js&"
export * from "./HomeVideo.vue?vue&type=script&lang=js&"
import style0 from "./HomeVideo.vue?vue&type=style&index=0&id=ed7e6dfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7e6dfc",
  null
  
)

export default component.exports